export class DomUtils{
    constructor(){}
    // ======
    // static
    // ------
    /**
     * 
     * @param bodyNode node or array of nodes
     * @param headNode node or array of nodes 
     * @returns 
     */
    static createDocument(bodyNode, headNode){  
        var doc = document.implementation.createDocument ('http://www.w3.org/1999/xhtml', 'html', null);
        var docHead = document.createElementNS('http://www.w3.org/1999/xhtml', 'head');
        doc.documentElement.appendChild(docHead);
        var docBody = document.createElementNS('http://www.w3.org/1999/xhtml', 'body');
        doc.documentElement.appendChild(docBody);
        DomUtils.appendChilds(docHead, headNode);
        DomUtils.appendChilds(docBody, bodyNode);
        return doc;
    }

    static removeChilds(element){
        while (element.childElementCount){ element.removeChild(element.firstElementChild) }
    }

    static appendChilds(parentNode,nodes){
        var nodes = DomUtils.toArray(nodes);
        if (nodes) nodes.forEach((node,index) =>{
            parentNode.appendChild(node);
        });         
    }

    static toArray(param){
        if (!param) return;
        if (param instanceof Array) return param;
        if (param instanceof NodeList) return DomUtils.nodeListToArray(param);
        return [param];
    }
    
    static nodeListToArray(param){
        if (param instanceof Array) return param;
        var nodes = [];
        if (param instanceof NodeList){
            param.forEach(node =>{ nodes.push(node) });             
        }
        return nodes;
    }
    static documentBodyNodes(doc){
        return  doc.body.childNodes;
    }

    static documentHeadNodes(doc){
        return doc.head.childNodes;
    }

    static getFirstChild(selector, domNode){  /* should change the name to getNode() */
        var childNode = domNode.querySelector(selector);
        return childNode;
    }

    static getAllChildren(selector, domNode){  /* should change the name to getNodes() */
        var children = domNode.querySelectorAll(selector);
        return children;
    }

    static  addClassList(classes, domNode){
        classes.forEach(klass => domNode.classList.add(klass));
    }

    static getClosest(selector, elmnt){
        return elmnt.closest(selector);
    }


    /**
     * returns the index of element in the list returned by getAllchildren 
     */
    static getElementIndex(element, selector, parentNode){
        var elements = DomUtils.getAllChildren(selector, parentNode);
        elements = DomUtils.toArray(elements);
        return elements.findIndex(el => (el === element))
    }


}